module.exports = __webpack_public_path__ + "img/애고미_이모티콘-02.3a7ce34.png";